import React from "react";

import "./productSliderSkeleton.scss";

const ProductSkeleton = ({
    amountOfFeatures = 0,
}: {
    showButton?: boolean;
    showCategoryLink?: boolean;
    amountOfFeatures?: number;
}) => (
    <div className="productTile product-tile--skeleton">
        <div className="productImage-wrapper">
            <div className="skeleton-product-tile__image" />
        </div>
        <h5 className="product-tile__title mb-md-0">
            <div className="skeleton-product-tile__title" />
        </h5>
        <div className="d-flex flex-wrap justify-content-between align-items-end my-2">
            <div></div>
            <div className="product-tile__price-block d-flex justify-content-end">
                <span className="price--medium">
                    <span className="skeleton-product-tile__price" />
                </span>
            </div>
        </div>
        {amountOfFeatures > 0 && (
            <div className="product-layout-description">
                <ul className="product-layout-description__list skeleton-product-tile__feature-list">
                    {[...Array(amountOfFeatures)].map(() => (
                        <li>
                            <span className="skeleton-product-tile__feature" />
                        </li>
                    ))}
                </ul>
            </div>
        )}
    </div>
);

const ProductSliderSkeletonComponent = ({
    title,
    amountOfFeatures = 0,
    isRecent = false,
}: {
    title?: string;
    amountOfFeatures?: number;
    isRecent?: boolean;
}) => {
    return (
        <div className={isRecent ? "productSlider-recents" : ""}>
            {title && <div>title</div>}
            <div className="product-tile__list--skeleton">
                <ProductSkeleton amountOfFeatures={amountOfFeatures} />
                <ProductSkeleton amountOfFeatures={amountOfFeatures} />
            </div>
        </div>
    );
};

export { ProductSliderSkeletonComponent };
